import styled from 'styled-components';

import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';

export const TopContainer = styled(SBHorizontal)`
  position: absolute;
  inset: var(--double-unit) var(--double-unit) auto;
`;
